module.exports = __webpack_public_path__ + "static/media/pulsidM.06d6c668.jpg";